import React from "react";
import classNames from "classnames";

import { BaseProps } from "@src/types/BaseProps.types";

import "./Input.scss";

interface InputProps extends BaseProps<HTMLInputElement> {
  type?: HTMLInputElement["type"];
  value?: HTMLInputElement["value"];
  label?: string;
  htmlFor?: HTMLLabelElement["htmlFor"];
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = ({
  type = "text",
  value,
  label,
  htmlFor,
  placeholder = "enter value",
  disabled = false,
  error,
  className,
  onChange,
  ...props
}: InputProps) => {
  const classes = classNames("input", { disabled: disabled, error: error }, className);

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={htmlFor} className="input-label">
          {label}
        </label>
      )}

      <input
        type={type}
        value={value}
        placeholder={placeholder}
        className="input-control"
        onChange={onChange}
        {...props}
      />

      {error && <p className="p0 warning input-error">{error}</p>}
    </div>
  );
};

export default Input;
